import React from 'react';
import { components } from 'react-select';
import CaretDownIcon from '@/components/icons/CaretDownIcon';
import XIcon from '@/components/icons/XIcon/XIcon';

export const DropdownIndicator = ({ ...props }) => {
  return (
    // @ts-ignore
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};

export const ClearIndicator = ({ ...props }) => {
  return (
    // @ts-ignore
    <components.ClearIndicator {...props}>
      <XIcon width={16} color="neutral_500" />
    </components.ClearIndicator>
  );
};
